var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding-block-1"},[(!_vm.isLoggedIn)?_c('LoginForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }